import { NodeNames, tosaErrorCodes as errorCodes } from '@farmersdog/constants';

import { ComponentName, LayoutType, NodeType } from '../../types';

import type { Fragment } from '../../types';

export const zipSentence = {
  name: 'zipSentence',
  type: NodeType.branch,
  layout: LayoutType.block,
  input: {
    excludeFromProgress: true,
  },
  children: [
    {
      name: NodeNames.Zip,
      type: NodeType.leaf,
      validation: NodeNames.Zip,
      layout: LayoutType.block,
      component: ComponentName.ZipInput,
      input: {
        label: 'My zip code is %input%',
        accessibleLabel: 'Zip code',
        placeholder: 'enter zip code',
      },
    },
    {
      name: 'zipError',
      type: NodeType.leaf,
      layout: LayoutType.block,
      component: ComponentName.InlineError,
      input: {
        errorMap: {
          [errorCodes.ZIP_INVALID]: 'Zip code must be exactly 5 digits.',
          [errorCodes.ZIP_NOT_SERVICEABLE]:
            'We only ship to mainland US, excluding Hawaii and Alaska.',
        },
        label: NodeNames.Zip,
        excludeFromProgress: true,
      },
    },
  ],
} as const satisfies Fragment;
